import React from 'react';

export default function BrokenLinkIcon() {
  return (
    <svg width="48" height="57" viewBox="0 0 48 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3229_425)">
        <path d="M4.62158 1.8291L43.6216 55.8291" stroke="currentColor" strokeWidth="4" />
        <path
          d="M36 18H26.4V22.8H36C39.96 22.8 43.2 26.04 43.2 30C43.2 33.96 39.96 37.2 36 37.2H26.4V42H36C42.624 42 48 36.624 48 30C48 23.376 42.624 18 36 18ZM21.6 37.2H12C8.04 37.2 4.8 33.96 4.8 30C4.8 26.04 8.04 22.8 12 22.8H21.6V18H12C5.376 18 0 23.376 0 30C0 36.624 5.376 42 12 42H21.6V37.2ZM14.4 27.6H33.6V32.4H14.4V27.6Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3229_425">
          <rect width="48" height="57" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
